import { SmsEspAccount } from 'modules/graphql/types';
import { SMS_VERIFICATION_PROFILE_TERM } from '../../../../constants';
import { useSendingPlatformsQueryContext } from '../../../../contexts';
import { VerificationProfileModal } from './VerificationProfileModal';

type Props = {
  espAccountId: number;
};

export const AddVerificationProfileModal = ({ espAccountId }: Props) => {
  const { selectEspAccount } = useSendingPlatformsQueryContext();
  const espAccount = selectEspAccount(espAccountId) as SmsEspAccount;

  if (!espAccount) return null;

  return (
    <VerificationProfileModal
      espAccount={espAccount}
      headerText={`Add ${SMS_VERIFICATION_PROFILE_TERM}`}
    />
  );
};
